/* eslint-disable prettier/prettier */
export const TYPES = {
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_LOGOUT: 'LOGIN_LOGOUT',
  LOGIN_ERROR: 'LOGIN_ERROR',
}
